const homeVideo = $('.home-video');
const videoID = homeVideo.data('videoid');
const videoType = homeVideo.data('type');

if(homeVideo) {
    let player;
    if($('#player').length > 0) {
        if(videoType == 'youtube'){
            function onYouTubeIframeAPIReady() {
            player = new YT.Player('player', {
                height: '581',
                width: '100%',
                videoId: videoID,
                playerVars: {
                    modestbranding: 1,
                    showinfo: 0,
                    controls: 0,
                    rel: 0,
                },
                events: {
                    'onStateChange': onPlayerStateChange
                }
            });
            }

            function onPlayerStateChange(event) {
                if (event.data == YT.PlayerState.PAUSED) {
                    homeVideo.removeClass('active')
                }
            }

            homeVideo.find('.btn-play').click(() => {
                homeVideo.addClass('active');
                player.playVideo();
            });
        }else{
            homeVideo.find('.btn-play').click(() => {
                homeVideo.addClass('active');
            });
        }

    }
    if($('#playerHtml').length > 0) {
        player = document.getElementById("playerHtml");

        player.onpause = function() {
            homeVideo.removeClass('active');
        };

        homeVideo.find('.btn-play').click(() => {
            homeVideo.addClass('active');
            player.play();
        });
    }
}